export default __webpack_public_path__ + "static/media/twelve.830a2451.jpg";